import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getFontWeightOptions } from "../../../utils/textStyleHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import { createH4Block, createPBlock } from "../../utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "itemCard",
  props: {
    image: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "48px",
                height: "48px",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
          },
        }),
      ],
    },
    header: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "Complete a Brief Application (5 Minutes)",
          styles: {
            fontWeight: getFontWeightOptions("600"),
          },
        }),
      ],
    },
    description: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "This helps me understand your goals and challenges.",
        }),
      ],
    },
  },
};
